export default __webpack_public_path__ + "static/media/46_BottomLeftSquares_Alpha.8386ab0b.mp4";